"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const store_1 = require("@ngrx/store");
const idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
const idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
const idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
const idm_dataset_service_client_js_1 = require("@synisys/idm-dataset-service-client-js");
const idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
const idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
const idm_me_client_js_1 = require("@synisys/idm-me-client-js");
const idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
const idm_ng_controls_1 = require("@synisys/idm-ng-controls");
const idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
const idm_um_client_js_1 = require("@synisys/idm-um-client-js");
const skynet_store_currencies_api_1 = require("@synisys/skynet-store-currencies-api");
const Observable_1 = require("rxjs/Observable");
const zip_1 = require("rxjs/observable/zip");
const operators_1 = require("rxjs/operators");
const Subject_1 = require("rxjs/Subject");
const reporting_category_value_loader_1 = require("../../../controls/reporting-filter/loader/reporting-category-value-loader");
const reporting_filter_component_1 = require("../../../controls/reporting-filter/reporting-filter.component");
const path_processing_helper_1 = require("../../../shared/path-processing-helper");
const common_helper_functions_1 = require("../../shared/common-helper-functions");
const filter_communication_key_1 = require("../model/filter-communication-key");
const filter_item_factory_1 = require("../model/filter-item-factory");
const filter_item_type_1 = require("../model/filter-item-type");
const page_filter_state_1 = require("../model/page-filter-state");
let PageFilterBuilderComponent = class PageFilterBuilderComponent {
    constructor(datasetService, pathService, measurePathService, currentLanguageProvider, languageService, messageService, store, kbService, classifierService, userService, authenticationService, meCategoriesCommonService, communicationService) {
        this.datasetService = datasetService;
        this.pathService = pathService;
        this.measurePathService = measurePathService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.languageService = languageService;
        this.messageService = messageService;
        this.store = store;
        this.kbService = kbService;
        this.classifierService = classifierService;
        this.userService = userService;
        this.authenticationService = authenticationService;
        this.meCategoriesCommonService = meCategoriesCommonService;
        this.communicationService = communicationService;
        this.initialized = false;
        this.availablePaths = [];
        this.FilterItemType = filter_item_type_1.FilterItemType;
        this.measurePathDetailDtoMap = new Map();
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(datasetService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(pathService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(currentLanguageProvider);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(languageService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(messageService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(kbService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(store);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(classifierService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(userService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(authenticationService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(meCategoriesCommonService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(communicationService);
        this.datasetId = null;
        this.stateChange = new core_1.EventEmitter();
        this.onDefaultValueChangeSubject$ = new Subject_1.Subject();
        this.destroy$ = new Subject_1.Subject();
        this.datasetDtoName = null;
        this.initPeersSubscription();
        this.loadLanguages();
        this.initOnValueChange();
    }
    set state(state) {
        if (state !== this.pageFilterStateEmitted || !this.pageFilterStateEmitted) {
            this.pageFilterState = page_filter_state_1.PageFilterState.fromJSON(state);
            this.selectedDatasetId = this.pageFilterState.datasetId;
            this.selectedPaths = this.pageFilterState.state;
            this.title = this.pageFilterState.title;
            this.isAutoApplyEnabled = this.pageFilterState.isAutoApplyEnabled;
        }
    }
    set selectedDatasetId(selectedDatasetId) {
        if (selectedDatasetId && selectedDatasetId > 0) {
            this.datasetId = selectedDatasetId;
            this.pageFilterState.datasetId = this.datasetId;
            this.loadDatasetAndPaths();
            this.emitState();
        }
        else {
            this.initDatasetsComboboxOptions();
        }
    }
    get selectedDatasetId() {
        return this.datasetId;
    }
    ngAfterViewInit() {
        this.initialized = true;
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    initDatasetsComboboxOptions() {
        this.datasetService.getDatasets()
            .then((datasetDtos) => {
            let options = [];
            datasetDtos.forEach((datasetDto) => {
                options.push(new idm_ng_controls_1.ComboboxOption(datasetDto.id, datasetDto.name));
            });
            this.datasetDtoComboboxOptions = options;
        })
            .catch((err) => {
            return common_helper_functions_1.defaultPromiseErrorHandler(err);
        });
    }
    loadLanguages() {
        this.languageService.getAvailableLanguages()
            .pipe(operators_1.takeUntil(this.destroy$))
            .catch((err) => {
            return Observable_1.Observable.fromPromise(common_helper_functions_1.defaultPromiseErrorHandler(err));
        })
            .subscribe((languages) => {
            this.languages = languages;
        });
        this.currentLanguageProvider.getCurrentLanguage()
            .pipe(operators_1.takeUntil(this.destroy$))
            .catch((err) => {
            return Observable_1.Observable.fromPromise(common_helper_functions_1.defaultPromiseErrorHandler(err));
        })
            .subscribe((language) => {
            this.currentLanguage = language;
        });
    }
    loadDatasetAndPaths() {
        if (Number.isInteger(this.datasetId)) {
            Promise.all([
                path_processing_helper_1.loadPaths(this.datasetId, this.pathService),
                path_processing_helper_1.loadPathGroups(this.datasetId, this.pathService),
                path_processing_helper_1.loadDatasetById(this.datasetId, this.datasetService),
                this.loadMetaCategories(),
                this.measurePathService.getMeasurePaths(this.datasetId)
            ])
                .then(([paths, pathGroups, datasetName, metaCategories, measurePathDetailDtoMap]) => {
                let availablePaths = new Map();
                reporting_filter_component_1.ReportingFilterComponent.extractAvailablePaths(paths.categoryPaths, availablePaths);
                reporting_filter_component_1.ReportingFilterComponent.extractAvailablePaths(paths.measurePaths, availablePaths);
                let availableCategories = new Map();
                reporting_filter_component_1.ReportingFilterComponent.extractAvailablePaths(paths.categoryPaths, availableCategories);
                this.categoryComboboxOptions = availableCategories.size > 0 ? path_processing_helper_1.initComboBoxOptions(Array.from(availableCategories.values())) : [];
                this.measurePathDetailDtoMap = measurePathDetailDtoMap;
                this.valueLoader = new reporting_category_value_loader_1.ReportingCategoryValueLoader(this.classifierService, this.userService, this.authenticationService, this.meCategoriesCommonService, this.currentLanguageProvider, availablePaths);
                this.constructPaths(availablePaths, pathGroups);
                this.filterItemFactory = new filter_item_factory_1.FilterItemFactory(metaCategories);
                this.datasetDtoName = datasetName;
            })
                .catch((err) => {
                return common_helper_functions_1.defaultPromiseErrorHandler(err);
            });
        }
    }
    loadMetaCategories() {
        return this.kbService.getAllMetaCategories('reporting')
            .map(metaCategories => {
            const map = new Map();
            metaCategories.forEach(metaCategory => {
                map.set(metaCategory.getSystemName(), metaCategory);
            });
            return map;
        })
            .first().toPromise()
            .catch((err) => {
            console.error("Failed with the following error: %o", err);
            return Promise.reject(err);
        });
    }
    constructPaths(paths, pathGroups) {
        zip_1.zip(this.messageService.getMessage("reporting.controls.chart-designer.text.ungrouped").pipe(operators_1.distinctUntilChanged()), skynet_store_currencies_api_1.getDefaultCurrency(this.store))
            .pipe(operators_1.takeUntil(this.destroy$))
            .subscribe(([message, currency]) => {
            this.availablePaths =
                path_processing_helper_1.initGroupedComboOptions(paths, pathGroups, this.currentLanguage, message, null, currency.id);
        });
    }
    onItemsValuesChange(selectedPaths) {
        this.selectedPaths = selectedPaths;
        this.pageFilterState.state = this.selectedPaths;
        this.emitState();
    }
    onSelectedFilterLabelChange(label) {
        this.selectedPaths[this.selectedFilterIndex].label = label;
        this.emitState();
    }
    onSelectedFilterValueChange() {
        this.selectedPaths[this.selectedFilterIndex].defaultValues = this.selectedFilterItem.getDefaultValue();
        this.emitState();
    }
    onTitleChange(title) {
        this.title = title;
        this.pageFilterState.title = this.title;
        this.emitState();
    }
    onLookupSelectionTypeChange(lookupSelectionType) {
        this.selectedPaths[this.selectedFilterIndex].lookupSelectionType = lookupSelectionType;
        this.emitState();
    }
    closeSelectedFilter() {
        this.communicationService.peerSubject.next({
            key: filter_communication_key_1.FilterCommunicationKey.ON_FILTER_UNSELECT
        });
    }
    clearSelectedState() {
        this.selectedFilterIndex = null;
        this.selectedFilterItem = null;
        this.isFilterItemSelected = false;
        this.compatibleCategoryComboboxOptions = [];
        this.selectedFilterItemPathName = null;
    }
    emitState() {
        this.pageFilterStateEmitted = this.pageFilterState.toJSON();
        this.stateChange.emit(this.pageFilterStateEmitted);
        this.preview();
    }
    preview() {
        let communicationData = new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.PREVIEW);
        this.communicationService.parentSubject.next(communicationData);
    }
    initOnValueChange() {
        this.onDefaultValueChangeSubject$.asObservable()
            .pipe(operators_1.debounceTime(500), operators_1.takeUntil(this.destroy$))
            .subscribe(() => {
            this.onSelectedFilterValueChange();
        });
    }
    initPeersSubscription() {
        this.communicationService.peerObservable
            .pipe(operators_1.takeUntil(this.destroy$))
            .subscribe((value) => {
            if (value.key === filter_communication_key_1.FilterCommunicationKey.ON_FILTER_SELECT) {
                this.selectedFilterIndex = value.index;
                this.isFilterItemSelected = true;
                this.selectedFilterItem = value.selectedFilterItem;
                this.selectedFilterItem.onValueChange = this.onDefaultValueChangeSubject$;
                if (this.selectedPaths[this.selectedFilterIndex].filterItemType === filter_item_type_1.FilterItemType.MEASURE_NUMBER) {
                    const compatibleCategoryIds = this.measurePathDetailDtoMap.get(this.selectedFilterItem.id).compatibleCategoryPathIds;
                    this.compatibleCategoryComboboxOptions = compatibleCategoryIds && compatibleCategoryIds.length > 0 ?
                        this.categoryComboboxOptions.filter(item => compatibleCategoryIds.includes(item.value)) : [];
                }
                for (let i = 0; i < this.availablePaths.length; i++) {
                    const items = this.availablePaths[i].items;
                    for (let j = 0; j < items.length; j++) {
                        if (items[j].value.id === this.selectedFilterItem.id) {
                            this.selectedFilterItemPathName = items[j].value.name;
                            break;
                        }
                    }
                    if (this.selectedFilterItemPathName)
                        break;
                }
                this.sendToParentSelectedState();
            }
            if (value.key === filter_communication_key_1.FilterCommunicationKey.ON_FILTER_UNSELECT) {
                this.clearSelectedState();
                this.sendToParentSelectedState();
            }
        });
    }
    sendToParentSelectedState() {
        let communicationData = new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.ITEM_SELECTED, {
            selected: this.isFilterItemSelected
        });
        this.communicationService.parentSubject.next(communicationData);
    }
    changeFilterAutoApplyEnabled(isAutoApplyEnabled) {
        this.isAutoApplyEnabled = isAutoApplyEnabled;
        this.pageFilterState.isAutoApplyEnabled = this.isAutoApplyEnabled;
        this.emitState();
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], PageFilterBuilderComponent.prototype, "id", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], PageFilterBuilderComponent.prototype, "state", null);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], PageFilterBuilderComponent.prototype, "stateChange", void 0);
PageFilterBuilderComponent = __decorate([
    core_1.Component({
        
        selector: 'sis-page-filter-builder',
        template: require('./page-filter-builder.component.html'),
        styles: [require('./page-filter-builder.component.css')],
    }),
    idm_dynamic_controls_metadata_1.ControlMetadata({
        template: "<sis-page-filter-builder [id]='%{id}' [state]='%{state}' (stateChange)='%{stateChange}'></sis-page-filter-builder>",
    }),
    __metadata("design:paramtypes", [idm_dataset_service_client_js_1.DatasetService,
        idm_dataset_service_client_js_1.PathService,
        idm_dataset_service_client_js_1.MeasurePathService,
        idm_session_data_provider_api_js_1.CurrentLanguageProvider,
        idm_message_language_service_client_js_1.LanguageService,
        idm_message_language_service_client_js_1.MessageService,
        store_1.Store,
        idm_kb_service_client_js_1.KbService,
        idm_classifier_service_client_js_1.ClassifierService,
        idm_um_client_js_1.UserService,
        idm_authentication_client_js_1.AuthenticationService,
        idm_me_client_js_1.CommonServicesProviderService,
        idm_dynamic_controls_metadata_1.CommunicationService])
], PageFilterBuilderComponent);
exports.PageFilterBuilderComponent = PageFilterBuilderComponent;
//# sourceMappingURL=page-filter-builder.component.js.map